import tables from './tables.vue';

export default { tables };
